/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiProblem,
  BackfillProgress,
  InputValidationProblem,
  ListOperations200Response,
  Log,
  Operation,
} from '../models';
import {
    ApiProblemFromJSON,
    ApiProblemToJSON,
    BackfillProgressFromJSON,
    BackfillProgressToJSON,
    InputValidationProblemFromJSON,
    InputValidationProblemToJSON,
    ListOperations200ResponseFromJSON,
    ListOperations200ResponseToJSON,
    LogFromJSON,
    LogToJSON,
    OperationFromJSON,
    OperationToJSON,
} from '../models';

export interface GetBackfillProgressRequest {
    projectIdOrName: string;
    integrationId: string;
    installationId: string;
    objectName: string;
}

export interface GetOperationRequest {
    projectIdOrName: string;
    operationId: string;
}

export interface ListOperationLogsRequest {
    projectIdOrName: string;
    operationId: string;
}

export interface ListOperationsRequest {
    projectIdOrName: string;
    integrationId: string;
    installationId: string;
    pageSize?: number;
    pageToken?: string;
}

/**
 * OperationApi - interface
 * 
 * @export
 * @interface OperationApiInterface
 */
export interface OperationApiInterface {
    /**
     * Retrieve backfill progress (records processed, estimated total) for an object. Use to track progress of an initial data sync.
     * @summary Get backfill progress
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} integrationId The Ampersand integration ID.
     * @param {string} installationId The Ampersand installation ID.
     * @param {string} objectName Name of the object being synced (e.g., \&quot;contact\&quot;, \&quot;account\&quot;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationApiInterface
     */
    getBackfillProgressRaw(requestParameters: GetBackfillProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BackfillProgress>>;

    /**
     * Retrieve backfill progress (records processed, estimated total) for an object. Use to track progress of an initial data sync.
     * Get backfill progress
     */
    getBackfillProgress(requestParameters: GetBackfillProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BackfillProgress>;

    /**
     * Retrieve a single operation by ID. An operation represents an async read, write, or subscribe action for an installation. Use this endpoint to poll for status, inspect the result summary, or fetch metadata such as read progress or write outcome details. 
     * @summary Get an operation
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} operationId Unique identifier for the operation. Obtain from the list operations API endpoint, the Ampersand dashboard, or webhook payloads.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationApiInterface
     */
    getOperationRaw(requestParameters: GetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Operation>>;

    /**
     * Retrieve a single operation by ID. An operation represents an async read, write, or subscribe action for an installation. Use this endpoint to poll for status, inspect the result summary, or fetch metadata such as read progress or write outcome details. 
     * Get an operation
     */
    getOperation(requestParameters: GetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Operation>;

    /**
     * 
     * @summary List logs for an operation
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} operationId Operation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationApiInterface
     */
    listOperationLogsRaw(requestParameters: ListOperationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Log>>>;

    /**
     * List logs for an operation
     */
    listOperationLogs(requestParameters: ListOperationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Log>>;

    /**
     * 
     * @summary List operations
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} integrationId The integration ID.
     * @param {string} installationId The Ampersand installation ID.
     * @param {number} [pageSize] The number of operations to return.
     * @param {string} [pageToken] A cursor that can be passed to paginate through multiple pages of operations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationApiInterface
     */
    listOperationsRaw(requestParameters: ListOperationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOperations200Response>>;

    /**
     * List operations
     */
    listOperations(requestParameters: ListOperationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOperations200Response>;

}

/**
 * 
 */
export class OperationApi extends runtime.BaseAPI implements OperationApiInterface {

    /**
     * Retrieve backfill progress (records processed, estimated total) for an object. Use to track progress of an initial data sync.
     * Get backfill progress
     */
    async getBackfillProgressRaw(requestParameters: GetBackfillProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BackfillProgress>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling getBackfillProgress.');
        }

        if (requestParameters.integrationId === null || requestParameters.integrationId === undefined) {
            throw new runtime.RequiredError('integrationId','Required parameter requestParameters.integrationId was null or undefined when calling getBackfillProgress.');
        }

        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling getBackfillProgress.');
        }

        if (requestParameters.objectName === null || requestParameters.objectName === undefined) {
            throw new runtime.RequiredError('objectName','Required parameter requestParameters.objectName was null or undefined when calling getBackfillProgress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/integrations/{integrationId}/installations/{installationId}/objects/{objectName}/backfill-progress`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))).replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters.integrationId))).replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))).replace(`{${"objectName"}}`, encodeURIComponent(String(requestParameters.objectName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BackfillProgressFromJSON(jsonValue));
    }

    /**
     * Retrieve backfill progress (records processed, estimated total) for an object. Use to track progress of an initial data sync.
     * Get backfill progress
     */
    async getBackfillProgress(requestParameters: GetBackfillProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BackfillProgress> {
        const response = await this.getBackfillProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a single operation by ID. An operation represents an async read, write, or subscribe action for an installation. Use this endpoint to poll for status, inspect the result summary, or fetch metadata such as read progress or write outcome details. 
     * Get an operation
     */
    async getOperationRaw(requestParameters: GetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Operation>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling getOperation.');
        }

        if (requestParameters.operationId === null || requestParameters.operationId === undefined) {
            throw new runtime.RequiredError('operationId','Required parameter requestParameters.operationId was null or undefined when calling getOperation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/operations/{operationId}`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))).replace(`{${"operationId"}}`, encodeURIComponent(String(requestParameters.operationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationFromJSON(jsonValue));
    }

    /**
     * Retrieve a single operation by ID. An operation represents an async read, write, or subscribe action for an installation. Use this endpoint to poll for status, inspect the result summary, or fetch metadata such as read progress or write outcome details. 
     * Get an operation
     */
    async getOperation(requestParameters: GetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Operation> {
        const response = await this.getOperationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List logs for an operation
     */
    async listOperationLogsRaw(requestParameters: ListOperationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Log>>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling listOperationLogs.');
        }

        if (requestParameters.operationId === null || requestParameters.operationId === undefined) {
            throw new runtime.RequiredError('operationId','Required parameter requestParameters.operationId was null or undefined when calling listOperationLogs.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/operations/{operationId}/logs`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))).replace(`{${"operationId"}}`, encodeURIComponent(String(requestParameters.operationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LogFromJSON));
    }

    /**
     * List logs for an operation
     */
    async listOperationLogs(requestParameters: ListOperationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Log>> {
        const response = await this.listOperationLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List operations
     */
    async listOperationsRaw(requestParameters: ListOperationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOperations200Response>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling listOperations.');
        }

        if (requestParameters.integrationId === null || requestParameters.integrationId === undefined) {
            throw new runtime.RequiredError('integrationId','Required parameter requestParameters.integrationId was null or undefined when calling listOperations.');
        }

        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling listOperations.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.pageToken !== undefined) {
            queryParameters['pageToken'] = requestParameters.pageToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/integrations/{integrationId}/installations/{installationId}/operations`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))).replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters.integrationId))).replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListOperations200ResponseFromJSON(jsonValue));
    }

    /**
     * List operations
     */
    async listOperations(requestParameters: ListOperationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOperations200Response> {
        const response = await this.listOperationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
